import { Link } from "react-router-dom";

import { Avatar } from "@mui/material";

import { DISPLAYING_FOR } from "../../config/AppEnums";

import "./css/user-meta-data.css";

import dpSrc from "../../functions/dpSrc";
import nameToColor from "../../functions/nameToColor";

const UserMetaData = (props) => {
    const { displayingFor, userId, name, askedOn, updatedOn } = props;

    return (
        <div className="user-meta-data">
            <div>
                <Avatar
                    src={dpSrc(userId)}
                    alt={name}
                    sx={{
                        bgcolor: nameToColor(name),
                        width: 48,
                        height: 48
                    }}
                />
            </div>

            <div className="umd-right">
                <div className="umdr-info">
                    <Link className="umdr-link title s-title" to={`/profile/${userId}`}>
                        {name}
                    </Link>
                </div>

                <span className="umdr-date">
                    {updatedOn !== askedOn && <>Updated on {updatedOn} • </>}
                    {displayingFor === DISPLAYING_FOR.DOUBT
                        ? "Asked"
                        : displayingFor === DISPLAYING_FOR.ANSWER
                            ? "Answered"
                            : "Commented"
                    } on {askedOn}
                </span>
            </div>
        </div>
    );
}

export default UserMetaData;